import { Button } from '../../../../../../../components/button/button';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import { TabsStepper } from '../../../../../../../components/tabs-stepper/tabs-stepper';
import { MenuInformerCreateMenuModalStep1 } from './menu-informer-create-menu-modal-step-1/menu-informer-create-menu-modal-step-1';
import { MenuInformerCreateMenuModalStep2 } from './menu-informer-create-menu-modal-step-2/menu-informer-create-menu-modal-step-2';
import { MenuInformerCreateMenuModalStep3 } from './menu-informer-create-menu-modal-step-3/menu-informer-create-menu-modal-step-3';
import s from './menu-informer-create-menu-modal.module.css';
import { useMenuInformerCreateMenuModal } from './use-menu-informer-create-menu-modal';

const stepComponents = [
  <MenuInformerCreateMenuModalStep1 />,
  <MenuInformerCreateMenuModalStep2 />,
  <MenuInformerCreateMenuModalStep3 />,
];

export const MenuInformerCreateMenuModal = (props: ModalProps) => {
  const { handleNextStep, handlePrevStep, step, t, isLoading, id, } =
    useMenuInformerCreateMenuModal(props);

  return (
    <Modal
      {...props}
      className={s.feature}
      title={t(id ? 'Редактирование меню' : 'Создание меню')}
      withLang
    >
      <TabsStepper titles={[t('Меню'), t('Разделы'), t('Категории')]} active={step} />
      {stepComponents[step]}
      <div className={s.controls}>
        <Button onClick={handlePrevStep} variant="secondary" data-testid="back-button">
          {t(stepComponents.length - step >= stepComponents.length ? 'Отменить' : 'Назад')}
        </Button>
        <Button onClick={handleNextStep} disabled={isLoading} data-testid="submit-button">
          {t(step >= stepComponents.length - 1 ? 'Сохранить' : 'Далее')}
        </Button>
      </div>
    </Modal>
  );
};
